module.exports = __webpack_public_path__ + "static/media/bell.f9c1b042.svg";